module.exports = __webpack_public_path__ + "static/img/bgi.be9b823c.jpg";